import React, { lazy, Suspense } from 'react';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import retry from '@wix/da-shared-react/pkg/utils/webpack/chunkRetry';

const LazyVideoUnlockWithCoreUpsellModal = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "video-unlock-core-upsell-modal" */
        './VideoUnlockWithCoreUpsellModal'
      )
  )
);

interface Props {
  requestClose: () => void;
}

const LoadableVideoUnlockWithCoreUpsellModal: React.FC<Props> = props => (
  <ErrorBoundary debugComponent="LoadableVideoUnlockWithCoreUpsellModal">
    <Suspense fallback={<LoadingIndicator view={'llama'} usePortal />}>
      <LazyVideoUnlockWithCoreUpsellModal {...props} />
    </Suspense>
  </ErrorBoundary>
);
LoadableVideoUnlockWithCoreUpsellModal.displayName = 'LoadableVideoUnlockWithCoreUpsellModal';

export default LoadableVideoUnlockWithCoreUpsellModal;
